<template>
	<div class="spiderWrapper">
		<div class="spiderWeb"><svg-sprite width="48" height="48" icon-id="spider-web-trap" halloween></svg-sprite></div>
		<div class="spider"><svg-sprite width="48" height="48" icon-id="spider" halloween></svg-sprite></div>
	</div>
</template>

<script>
export default {
	name: "spider-halloween"
};
</script>

<style lang="scss">

.avatarWrap {
	position: relative;
	overflow: visible;

	.v-avatar {
		position: relative;
		z-index: 50;
	}

	.spiderWeb {
		position: absolute;
		top: 0; left: 0;
		z-index: 100;
		transition: opacity .3s, visibility .3s;
		opacity: 0.5; visibility: visible;
	}

	.spider {
		position: absolute;
		top: 0; left: 0;                  // якщо треба по центру над аватаром: left: 50%; transform: translate(-50%,0);
		z-index: 10;
		transform: translateY(0);
		will-change: transform;
		pointer-events: none;

		/* НИТКА (від .v-avatar до павука). Малюємо як псевдоелемент */
		&::before {
			content: "";
			position: absolute;
			left: 50%;
			transform: translateX(-50%);   // центруємо нитку відносно павука
			bottom: 100%;                  // кріпимо нитку до верхнього краю павука й тягнемо вгору
			width: 2px;
			height: 0;                     // буде анімуватись
			background: linear-gradient(to bottom, rgba(255,255,255,.4), rgba(255,255,255,.35));
			box-shadow: 0 0 6px rgba(255,255,255,.2);
			border-radius: 2px;
			z-index: -1;                   // позаду павука
			pointer-events: none;
		}
	}

	&:hover {
		.spiderWeb { opacity: 0; visibility: hidden; }
		.spider { animation: spiderDance 1.6s both; }
		.spider::before { animation: spiderThread 1.6s both; }
	}
}

/* Рух павука: швидко 70vh → плавно 45vh → швидко 60vh → плавно в 0 */
@keyframes spiderDance {
	0%   { transform: translateY(0);      animation-timing-function: cubic-bezier(.2,.9,.3,1); }
	15%  { transform: translateY(70vh);   animation-timing-function: cubic-bezier(.25,.1,.25,1); }
	60%  { transform: translateY(45vh);   animation-timing-function: cubic-bezier(.2,.9,.3,1); }
	75%  { transform: translateY(60vh);   animation-timing-function: cubic-bezier(.25,.1,.25,1); }
	100% { transform: translateY(0); }
}

/* Довжина нитки — синхронна позиції павука (від “аватара”/верху контейнера до павука) */
@keyframes spiderThread {
	0%   { height: 0;       animation-timing-function: cubic-bezier(.2,.9,.3,1); }
	15%  { height: 70vh;    animation-timing-function: cubic-bezier(.25,.1,.25,1); }
	60%  { height: 45vh;    animation-timing-function: cubic-bezier(.2,.9,.3,1); }
	75%  { height: 60vh;    animation-timing-function: cubic-bezier(.25,.1,.25,1); }
	100% { height: 0; }
}

/* Менше руху для тих, хто просить */
@media (prefers-reduced-motion: reduce) {
	.avatarWrap .spider { animation: none !important; transform: translateY(0); }
	.avatarWrap .spider::before { animation: none !important; height: 0; }
}

</style>
